import Image from "@namia/image";
import React from "react";

const HcHighlight = ({ image, content }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-highlight wp-block-kehittamo-block-hc">
      <div className="flex justify-center items-center">
        <div className="flex gap-3 xl:gap-36 flex-col items-center xl:flex-row">
          <div
            dangerouslySetInnerHTML={{ __html: content }}
            className="max-w-[740px] xl:w-2/3 xl:order-last xl:pr-7"
          ></div>
          <div className="max-w-96 xl:w-1/3 xl:order-first">
            <Image
              className=""
              alt="alt"
              base64={image.base64}
              onError={() => {}}
              placeholder={image.placeholder}
              onLoad={() => {}}
              placeholderBase64={image.placeholderBase64}
              ratio={image.width / image.height}
              src={image.src}
              srcset={image.srcset}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HcHighlight;
